exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Kv4F{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;padding:6px 0 8px;font-weight:400}._1QEPi{width:30px;margin-right:10px;border:none;cursor:pointer}._1weVC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-right:5px}.zJ6Ue{margin:0;font-size:16px;font-weight:700;line-height:21px;text-decoration:none;color:#000;padding-bottom:3px;cursor:pointer}._3xqxl{margin:0;font-size:12px;line-height:16px}.qT-Bi{color:#666b6f;text-decoration:none;font-size:13px;line-height:1.43;outline:none;cursor:pointer}.qT-Bi:after{content:\", \";display:inline}.qT-Bi:last-child:after{content:none}.qT-Bi:hover{color:#e73232;text-decoration:none}.qT-Bi:hover:after{color:#666b6f}", ""]);

// exports
exports.locals = {
	"makesItem": "_3Kv4F",
	"logo": "_1QEPi",
	"makeWithModels": "_1weVC",
	"make": "zJ6Ue",
	"models": "_3xqxl",
	"model": "qT-Bi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/MakesSidebar/MakesItem/MakesItem.css
// module id = 1472
// module chunks = 0 1 15 16 17 20 21 22 23 24 28 33 36 38 44